(function () {
  'use strict';

  const grid = document.getElementById('blog-landing-grid');
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll('.blog-landing__card'));
  const tabs = document.querySelectorAll('.blog-landing__tab');

  if (tabs.length === 0) return;

  function filterCards(tabValue) {
    cards.forEach(function (card) {
      var blog = card.getAttribute('data-blog');

      if (tabValue === 'all' || blog === tabValue) {
        card.classList.remove('is-hidden');
      } else {
        card.classList.add('is-hidden');
      }
    });

    // Update URL hash for shareability (no page scroll)
    if (tabValue !== 'all') {
      history.replaceState(null, '', '#tab-' + tabValue);
    } else {
      history.replaceState(null, '', window.location.pathname);
    }
  }

  // Tab click handler
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabValue = tab.getAttribute('data-tab');
      if (tab.classList.contains('is-active')) return;  // Skip if already active

      // Update active tab styling
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      filterCards(tabValue);
    });
  });

  // Restore tab from URL hash on page load
  (function initFromHash() {
    var hash = window.location.hash;
    if (hash && hash.indexOf('#tab-') === 0) {
      var tabValue = hash.replace('#tab-', '');
      var match = Array.from(tabs).find(function (t) {
        return t.getAttribute('data-tab') === tabValue;
      });
      if (match) {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        match.classList.add('is-active');
        match.setAttribute('aria-selected', 'true');
        filterCards(tabValue);
      }
    }
  })();
})();
